(function () {
  var started = false;
  var granted = false;
  window.dataLayer = window.dataLayer || [];
  function queue() {
    window.dataLayer.push(arguments);
  }
  function consent(command, value) {
    queue('consent', command, {
      analytics_storage: value,
      ad_storage: value,
      ad_user_data: value,
      ad_personalization: value
    });
  }
  consent('default', 'denied');
  function sync() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return;
    var choice = privacy.currentVisitorConsent();
    var allowed = choice.analytics === 'yes' && choice.marketing === 'yes' &&
      privacy.analyticsProcessingAllowed() && privacy.marketingAllowed();
    if (allowed !== granted) {
      granted = allowed;
      consent('update', allowed ? 'granted' : 'denied');
    }
    if (!allowed || started) return;
    started = true;
    ['GTM-56G6GBV5', 'GTM-NSR7W2ZG'].forEach(function (id) {
      window.dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtm.js?id=' + id;
      document.head.appendChild(script);
    });
  }
  function ready() {
    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], function (error) {
      if (!error) sync();
    });
  }
  document.addEventListener('visitorConsentCollected', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
}());
